import React, { useRef, useState, useEffect } from "react";
import { useMemo, useCallback } from "react";
import { useParams } from "react-router-dom";
import { getPodCastEpisodeFromApi } from "../common/api";
import PodCastAudioPlayer from "./PodCastAudioPlayer";
import PodCastTextContent from "./PodCastTextContent";
import BeatLoader from "react-spinners/BeatLoader";
const PodCast = () => {
  const [isPlaying, setIsPlaying] = useState(true);
  const { podcastId } = useParams();
  const abortControllerRef = useRef(null);
  const [data, setData] = useState({
    podcast: {},
    loading: false,
    message: "",
    error: "",
  });
  const { podcast, loading, message, error } = data;
  const getEpisode = useCallback(async () => {
    try {
      setData({ ...data, loading: true, error: "", message: "" });
      const results = await getPodCastEpisodeFromApi({
            abortControllerRef,
            podcastId,
          });
      setData({
        ...data,
        podcast: { ...results.data },
        loading: true,
        error: "",
        message: `${Object.keys(results.data).length ? "" : "No Results Found!"}`,
      });
    } catch (error) {
      const { message } = error;
      if (message !== "canceled") {
        setData({
          ...data,
          podcasts: [],
          loading: false,
          message: "",
          error: message,
        });
      }
    }
  }, [podcastId]);

  useEffect(() => {
    const abortControllerRefCopy = abortControllerRef;
    getEpisode();
    return () => abortControllerRefCopy.current?.abort();
  }, [podcastId]);
  const audioPlayerRef = useRef();
  const content = useMemo(() => {
    return Object.keys(podcast);
  }, [podcast]);
  const results = content?.length ? (
    <>
      <div className="sticky top-0 bg-linen w-full mx-auto py-1 px-2">
        <h1 className=" w-full truncate text-center capitalize text-customFontFourteen font-semibold my-2 underline">
          {podcast.title}
        </h1>
        <PodCastAudioPlayer
          AudioPlayerComponentProps={{
            isPlaying,
            setIsPlaying,
            audioUrl: podcast.audio_url,
          }}
          ref={audioPlayerRef}
        />
      </div>
      <div className="w-full mx-auto py-1">
        <PodCastTextContent
          podCastTextContentProps={{
            audioPlayerCopy: audioPlayerRef,
            setIsPlaying,
            audioText: podcast.transcript,
          }}
        />
      </div>
    </>
  ) : (
    <div className="w-full bg-inherit">
      {loading && (
        <div className="w-full text-center">
          <BeatLoader color="#40464F" />
        </div>
      )}
      {message && (
        <p className="w-full text-customFontThree text-center text-black dark:text-white">
          {message}
        </p>
      )}
      {error && (
        <p className="w-full text-customFontThree text-red-500 text-center">
          {error}
        </p>
      )}
    </div>
  );

  return (
    <div className="min-h-screen w-full bg-linen  p-2 text-black">
      {results}
    </div>
  );
};

export default PodCast;
